import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Spinner } from 'react-bootstrap';
import FacturaCard from './FacturaCard';

const FacturasConciliarLista = ({
    rfcSeleccionado,
    cargandoFacturas,
    facturasFiltradas,
    facturasSeleccionadas,
    toggleSeleccionFactura,
    movimientosSeleccionados,
    onConciliar,
    cargandoConciliacion
}) => {
    return (
        <div style={{ maxHeight: '550px', overflowY: 'auto' }}>
            <Row className="g-3">
                {!rfcSeleccionado ? (
                    <Col xs={12}>
                        <div className="text-center text-600 py-5">
                            <i className="fas fa-exclamation-triangle fa-2x mb-3 text-warning"></i>
                            <p className="mb-0">Seleccione un RFC para ver las facturas</p>
                        </div>
                    </Col>
                ) : cargandoFacturas ? (
                    <Col xs={12}>
                        <div className="text-center py-5">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2 text-muted">Cargando facturas...</p>
                        </div>
                    </Col>
                ) : facturasFiltradas.length > 0 ? (
                    facturasFiltradas.map((factura) => (
                        <Col xs={12} key={factura.id}>
                            <FacturaCard
                                factura={factura}
                                facturasSeleccionadas={facturasSeleccionadas}
                                toggleSeleccionFactura={toggleSeleccionFactura}
                                onConciliar={onConciliar}
                                movimientoSeleccionado={movimientosSeleccionados[0]}
                                cargandoConciliacion={cargandoConciliacion}
                            />
                        </Col>
                    ))
                ) : (
                    <Col xs={12}>
                        <div className="text-center text-600 py-5">
                            <i className="fas fa-file-invoice fa-2x mb-3 text-300"></i>
                            <p className="mb-0">No se encontraron facturas con los filtros actuales</p>
                        </div>
                    </Col>
                )}
            </Row>
        </div>
    );
};



FacturasConciliarLista.propTypes = {
    rfcSeleccionado: PropTypes.string,
    cargandoFacturas: PropTypes.bool,
    facturasFiltradas: PropTypes.array,
    facturasSeleccionadas: PropTypes.array,
    toggleSeleccionFactura: PropTypes.func,
    movimientosSeleccionados: PropTypes.array,
    onConciliar: PropTypes.func
};

export default FacturasConciliarLista;
